import React from 'react';
import { JobsTrendChart } from '../Charts/JobsTrendChart';

const JobsTrend = ({ data = [] }) => (
  <div className="white-wraper extra-mt">
    <h2 className="add-margin">Job Trend ({data?.[0]?.year ?? new Date().getFullYear()})</h2>
    <div className="chart-data">
      <ul>
        <li><div className="chart-dot cd1"></div><p>Posted</p></li>
        <li><div className="chart-dot cd10"></div><p>Pending</p></li>
        <li><div className="chart-dot cd3"></div><p>In Progress</p></li>
        <li><div className="chart-dot cd2"></div><p>Completed</p></li>
        <li><div className="chart-dot cd4"></div><p>Cancelled</p></li>
      </ul>
    </div>

    <div className="chart-canvas">
      {data.length > 0 ? (
        <JobsTrendChart data={data} />
      ) : (
        <div className="text-center text-secondary" style={{ display:'flex', width:'100%', alignItems:'center', justifyContent:'center' }}>No data available</div>
      )}
    </div>
  </div>
);

export default JobsTrend;
